// extracted by mini-css-extract-plugin
export default {"light":"ThemeIcons_light__juoNt","system":"ThemeIcons_system__bSAyl","dark":"ThemeIcons_dark__pm+zr"};